import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { IonButton, IonIcon, IonItem } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline, pencilOutline } from 'ionicons/icons';
import { Observable } from 'rxjs';
import { PaymentInfo, PaymentStatus, SlipInfo } from '../../student-slip-modal.store';
import { FormState, WebPaymentFormStore } from './web-payment-form.store';

declare const Stripe: any;

@Component({
  selector: 'app-web-payment-form',
  templateUrl: './web-payment-form.component.html',
  styleUrls: ['./web-payment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [WebPaymentFormStore],
  imports: [FormsModule, ReactiveFormsModule, AsyncPipe, IonIcon, IonItem, IonButton]
})
export class WebPaymentFormComponent implements OnInit, OnDestroy {
  @Input() set slipInfo(value: SlipInfo) {
    this.store.setSlipInfo(value);
  }
  @Input() paymentInfo: PaymentInfo;
  @Input() paymentStatus: PaymentStatus;

  @Output() readonly paymentStatusChange = this.store.paymentStatus$;
  @ViewChild('cardInfo', { static: false }) set cardInfo(value: ElementRef) {
    if (value) {
      this.store.initialiseStripe({
        stripe: this.stripe,
        cardInfo: value
      });
    }
  }
  stripe: any;
  paymentForm = this.fb.group({});

  readonly vm$: Observable<FormState> = this.store.vm$;

  constructor(
    private store: WebPaymentFormStore,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef
  ) {
    addIcons({ pencilOutline, informationCircleOutline });
  }

  ngOnInit(): void {
    this.store.setPaymentStatus(this.paymentStatus);
    this.store.setPaymentInfo(this.paymentInfo);
    this.store.setPayNowAmount(this.paymentInfo.balance);
    this.stripe = Stripe(this.paymentInfo.paymentKey);
  }

  ngOnDestroy(): void {
    this.store.destroyCard();
  }

  onEditAmount(): void {
    this.store.editAmount();
  }

  setupStripe(): void {
    this.store.initialiseStripe({
      stripe: this.stripe,
      cardInfo: this.cardInfo
    });
  }

  async onSubmit(): Promise<void> {
    if (this.paymentForm.valid) {
      this.store.payNow({ stripe: this.stripe });
    }
  }
}
